import API from "./api"

import { isNotAValue } from "web/services/helpers"

export default function useSearch(scope = "all") {
  return async (query, options = {}) => {
    if (isNotAValue(query)) return []
    return await API.get(`/search/${scope}`, {
      query,
      ...options,
    })
  }
}
